import { render, staticRenderFns } from "./SmtBomTable.vue?vue&type=template&id=4d3cfbb5&scoped=true"
import script from "./SmtBomTable.vue?vue&type=script&lang=js"
export * from "./SmtBomTable.vue?vue&type=script&lang=js"
import style0 from "./SmtBomTable.vue?vue&type=style&index=0&id=4d3cfbb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cfbb5",
  null
  
)

export default component.exports